import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A8CFF',
      dark: '#0F62CC',
      light: '#E8F4FF',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A',
      secondary: '#64748B',
      disabled: '#94A3B8',
    },
    success: { main: '#10B981' },
    warning: { main: '#F59E0B' },
    error: { main: '#EF4444' },
    info: { main: '#3B82F6' },
    divider: '#E2E8F0',
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h5: { fontWeight: 700, fontSize: '1.5rem' },
    h6: { fontWeight: 600, fontSize: '1.125rem' },
    body1: { fontSize: '0.875rem' },
    body2: { fontSize: '0.75rem', fontWeight: 500 },
    caption: { fontSize: '0.72rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' },
  },
  shape: { borderRadius: 8 },
  shadows: [
    'none',
    '0 1px 3px rgba(0,0,0,0.08)',
    '0 4px 12px rgba(0,0,0,0.1)',
    ...Array(22).fill('0 4px 12px rgba(0,0,0,0.1)'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, textTransform: 'none', fontWeight: 600, boxShadow: 'none' },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1A8CFF, #0F62CC)',
          '&:hover': { background: 'linear-gradient(135deg, #0F62CC, #0A4FA3)', boxShadow: 'none' },
          /* A DISABLED BUTTON MUST LOOK DISABLED, everywhere.
             MUI greys a disabled contained button by setting background-COLOR — which the
             gradient above, a background-IMAGE, paints straight over. So every primary
             button in the app stayed full blue while unclickable: people tap it, nothing
             happens, and they assume it is broken. Clearing the image is the part that
             matters; the colour alone does nothing.
             (user 2026-10-31: "if not able to click then grey bit better" / "the grey
              button can apply for those cant click one") */
          '&.Mui-disabled': {
            background: '#E2E8F0',
            backgroundImage: 'none',
            color: '#94A3B8',
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', size: 'small' },
      styleOverrides: {
        root: { '& .MuiOutlinedInput-root': { borderRadius: 8, backgroundColor: '#FAFAFA' } },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 600, fontSize: '0.75rem' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 14, backgroundImage: 'none' },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          textTransform: 'uppercase',
          fontSize: '0.72rem',
          fontWeight: 600,
          letterSpacing: '0.5px',
          color: '#64748B',
        },
      },
    },
  },
});

export default theme;
